import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX, ZendraLocalizationServices, triggerAction, IActionsSchema, ActionOverRecordTypes } from '@zendra/shared';
import { CertifiedRegisters } from './certified-registers/certified-registers';
import { CertifiedStands } from './certified-stands/certified-stands';
import { CertifiedContracts } from './certified-contracts/certified-contracts';
import { CertifiedThirdPartyProperty } from './certified-third-party-property/certified-third-party-property';
import { CertificateTypeService, CertificationLevelService, CertificationTypeService, CertificatorService, ManagementTypeService, WoodStatementService } from 'cbd-proxies/planning/proxy';

FieldBuilder.setNamespace('Geographic');

export const WOODCERTIFICATION_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('certificationCode', 'Entity.WoodCertification.CertificationCode')
    .required()
    .maxLength(50)
    .build(),
  FieldBuilder
    .number('initialArea', 'Entity.WoodCertification.InitialArea')
    .decimal()
    .build(),
  FieldBuilder.foreignKey('certificationTypeId', 'Entity.CertificationType', CertificationTypeService)
    .required()
    .display('name')
    .displayFromNested('certificationTypeName')
    .sortBy('certificationTypeName')
    .keyField("id")
    .build(),
  FieldBuilder.foreignKey('managementTypeId', 'Entity.ManagementType', ManagementTypeService)
    .required()
    .display('name')
    .displayFromNested('managementTypeName')
    .sortBy('managementTypeName')
    .keyField("id")
    .build(),
  FieldBuilder.foreignKey('certificationLevelId', 'Entity.CertificationLevel', CertificationLevelService)
    .display('name')
    .displayFromNested('certificationLevelName')
    .sortBy('certificationLevelName')
    .keyField("id")
    .hideByDefault()
    .build(),
  FieldBuilder.foreignKey('certificateTypeId', 'Entity.CertificateType', CertificateTypeService)
    .required()
    .display('name')
    .displayFromNested('certificateTypeName')
    .sortBy('certificateTypeName')
    .keyField("id")
    .build(),
  FieldBuilder.foreignKey('woodStatementId', 'Entity.WoodStatement', WoodStatementService)
    .required()
    .display('name')
    .displayFromNested('woodStatementName')
    .sortBy('woodStatementName')
    .keyField("id")
    .hideByDefault()
    .build(),
  FieldBuilder.foreignKey('certificatorId', 'Entity.Certificator', CertificatorService)
    .required()
    .display('name')
    .displayFromNested('certificatorName')
    .sortBy('certificatorName')
    .keyField("id")
    .build(),
  FieldBuilder
    .date('startDate', 'Entity.WoodCertification.StartDate')
    .required()
    .build(),
  FieldBuilder
    .date('finishDate', 'Entity.WoodCertification.FinishDate')
    .required()
    .equalOrGreaterThanField('startDate', 'Entity.WoodCertification.StartDate')
    .build(),
  FieldBuilder
    .text('notes', 'Entity.WoodCertification.Notes')
    .maxLength(200)
    .hideByDefault()
    .build(),
];

const namespace = ZendraLocalizationServices.Geographic;

export const CERTIFICATION_ACTION_IDS = {
  updateCertificationTrigger: 0
}

export const  CERTIFICATION_ACTIONS_CONFIG: IActionsSchema = {
  singleRecord: [
    triggerAction(
      CERTIFICATION_ACTION_IDS.updateCertificationTrigger,
      'Action.Trigger.UpdateCertifications',
      ActionOverRecordTypes.SingleRecord,
      namespace,
    )
  ],
};

export const WOODCERTIFICATION_CONFIG = {
  entityName: 'WoodCertification',
  localizationKey: 'Geographic::Entity.WoodCertification',
  fields: WOODCERTIFICATION_FIELDS,
  actions: CERTIFICATION_ACTIONS_CONFIG,
  actionIds: CERTIFICATION_ACTION_IDS,
  permission: 'PlanningGeography.WoodCertifications',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Certification + MENU_NAME_SUFFIX,
  menuSubcategory: '',
  children: [
    {
      entityName: 'CertifiedRegisters',
      foreignKeyField: 'woodCertificationId',
      localizationKey: 'Geographic::WoodCertificationDetail.CertifiedRegisters',
      component: CertifiedRegisters,
    },
    {
      entityName: 'CertifiedStands',
      foreignKeyField: 'woodCertificationId',
      localizationKey: 'Geographic::WoodCertificationDetail.CertifiedStands',
      component: CertifiedStands,
    },
    {
      entityName: 'CertifiedThirdPartyProperty',
      foreignKeyField: 'woodCertificationId',
      localizationKey: 'Geographic::WoodCertificationDetail.CertifiedThirdPartyProperty',
      component: CertifiedThirdPartyProperty,
    },
    {
      entityName: 'CertifiedContracts',
      foreignKeyField: 'woodCertificationId',
      localizationKey: 'Geographic::WoodCertificationDetail.CertifiedContracts',
      component: CertifiedContracts,
    },
  ],
};
